import { Input } from 'antd';
import { AutoComplete, AutoCompleteProps } from './autocomplete';
import { IBank } from '../../../interfaces/banks';
import { mapBankItem } from '../../../utils/edit.constants';
import { DownOutlined } from '@ant-design/icons';

export const AutoCompleteBankInput = (props: Omit<AutoCompleteProps<IBank>, 'mapItem'>) => (
  <AutoComplete
    {...props}
    resource={props.resource ?? 'api/v1/banks'}
    mapItem={mapBankItem}
    notFoundPlaceholder='Type in Bank name or SWIFT to search'
  >
    <Input placeholder='Bank (Name, SWIFT)' size='large' suffix={<DownOutlined />} />
  </AutoComplete>
);
